
import React from 'react';
import { graphql } from 'gatsby';
import { buildStory, datoToISF } from '@titelmedia/hs-bricks-npm';

export default ({ data }) => {
  const { allDatoCmsStory } = data;
  const storyNode = allDatoCmsStory.edges.length
    ? allDatoCmsStory.edges[0].node
    : null;
  const content = datoToISF({ content: storyNode.storyContent });
  const settings = {
    shouldDisplayHeader: storyNode.displayHeader,
    shouldDisplayArticleFooter: storyNode.displayArticleFooter,
    shouldDisplayPresentedBy: storyNode.displayPresentedBy,
  };

  return (
    <React.Fragment>
      {buildStory({ content })}
      <code dangerouslySetInnerHTML={{ __html: JSON.stringify(settings) }} />
    </React.Fragment>
  );
};

export const query = graphql`
  query StoryQuery {
    allDatoCmsStory(filter: { id: { eq: "DatoCmsStory-23442029-en" } }) {
      edges {
        node {
          id
          displayHeader
          displayArticleFooter
          displayPresentedBy
          storyContent {
            ... on DatoCmsLayoutDivider {
              id
              layoutType
              title
              colorMode
              backgroundColor {
                hex
                green
                blue
                alpha
                red
              }
              backgroundImage {
                fluid {
                  src
                }
              }
            }
            ... on DatoCmsParagraph {
              id
              text
            }
            ... on DatoCmsHighlight {
              id
              text
            }
            ... on DatoCmsQuote {
              id
              text
              source
            }
            ... on DatoCmsImage {
              id
              items {
                alt
                fluid {
                  src
                  srcSet
                  aspectRatio
                }
              }
            }
            ... on DatoCmsCta {
              id
              text
              url
            }
            ... on DatoCmsVideo {
              id
              providerUid
            }
            ... on DatoCmsGallery {
              id
              galleryType
              items {
                alt
                fluid {
                  src
                  srcSet
                  aspectRatio
                  height
                  width
                }
              }
            }
          }
        }
      }
    }
  }
`;
